import React, {useState} from "react";

import * as GroupGameService from "../../api/GroupGameService"
import {Button, Form, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle} from "react-bootstrap";
import {useTranslation} from "react-i18next";

export default function HistoryPlayerRequestModal(props) {
    const { t, i18n } = useTranslation('translation', { keyPrefix: 'historyPlayerRequestModal' });
    const [playerRequest, setPlayerRequest] = useState(props.user_request)

    function savePlayerRequest() {
        GroupGameService.postPlayerRequest(
            props.gameId,
            props.playerId,
            playerRequest !== undefined ? playerRequest : props.user_request,
            () => {},
            () => window.alert("Failed to save")
        )
        props.onClose()
    }

    function storeRequest(event) {
        setPlayerRequest(event.target.value)
        event.target.style.height = "auto"
    }

    return (
        <Modal
            show={true}
            onHide={props.onClose}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <ModalHeader closeButton>
                <ModalTitle>{t('playerRequest')}</ModalTitle>
            </ModalHeader>
            <ModalBody style={{backgroundColor: "#FCF2ED"}}>
                <Form>
                    <Form.Control
                        as="textarea"
                        rows={12}
                        onFocus={(e)=> {e.target.selectionStart = playerRequest?.length}}
                        onChange={e => storeRequest(e)}
                        value={playerRequest}
                        autoFocus={true}
                    />
                </Form>
            </ModalBody>
            <ModalFooter>
                <Button variant="primary" onClick={savePlayerRequest} style={{backgroundColor: "#59619B"}}>
                    {t('saveButton')}
                </Button>
            </ModalFooter>
        </Modal>
    )

}